import React from 'react'
import styles from './CssLoader.module.css';

const CssLoader = () => {
  return (
    <div className={styles.customLoader}>Loading...</div>
  )
}

export default CssLoader;
